// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["critical/critical-js"], () => (__webpack_require__("./app/frontend/assets/js/widgets/main-menu-v1/main-menu-v1.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["critical/critical-js"], () => (__webpack_require__("./app/frontend/assets/js/widgets/main-sub-menu-v1/main-sub-menu-v1.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
